import { vappContainer, VApplication } from '../../../../../application';
import { logger as log } from '@common/logger';
import { ApplicationDetailPageService } from '../../../services';

const MODULE_NAME = 'profile.machines.states.getApplication';

const getSrv = () => {
  return vappContainer.get<ApplicationDetailPageService>(
    ApplicationDetailPageService.displayName
  );
};
export const getApplication = async (context: any, event: any) => {
  const currentState = 'GET_APPLICATION';
  const method = 'getApplication';

  return new Promise(async (resolve, reject) => {
    try {
      log.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      log.log(MODULE_NAME, 'context: ', context, 'event: ', event);

      const srv = getSrv();
      const content = await srv?.agent?.getApplicationDetail({});

      if (content) {
        return resolve({
          key: 'RENDER_APPLICATION',
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = 'Page content not found';
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        return reject({
          key: 'RENDER_APPLICATION_ERROR',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      let _msg = err?.message?.replace('GraphQL error:', '');
      return reject({
        key: 'RENDER_APPLICATION_ERROR',
        value: _msg,
      });
    }
  });
};
